import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import api from "@/lib/api";

// Live countdown to the next 00:00 Asia/Dubai (GST) ROI payout.
export function PayoutCountdown({ compact = false }) {
  const [target, setTarget] = useState(null);
  const [left, setLeft] = useState("");
  const [roiTime, setRoiTime] = useState("00:00");

  useEffect(() => {
    let alive = true;
    const load = () => api.config().then((c) => {
      if (!alive) return;
      if (c?.next_payout_at) setTarget(new Date(c.next_payout_at));
      if (c?.roi_payout_gst) setRoiTime(c.roi_payout_gst);
    }).catch(() => {});
    load();
    const iv = setInterval(load, 5 * 60 * 1000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  useEffect(() => {
    if (!target) return;
    const tick = () => {
      let ms = target - new Date();
      if (ms <= 0) { setLeft("Settling…"); return; }
      const h = Math.floor(ms / 3.6e6);
      const m = Math.floor((ms % 3.6e6) / 6e4);
      const s = Math.floor((ms % 6e4) / 1e3);
      setLeft(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`);
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [target]);

  if (compact) {
    return (
      <span data-testid="payout-countdown" className="inline-flex items-center gap-1.5 text-xs font-num gold-text">
        <Timer className="w-3.5 h-3.5" /> {left || "—"}
      </span>
    );
  }

  return (
    <div data-testid="payout-countdown" className="rounded-xl border border-[#C6A15B]/25 bg-[#C6A15B]/[0.06] px-4 py-3 flex items-center gap-3">
      <Timer className="w-4 h-4 gold-text shrink-0" />
      <div>
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Next ROI + prediction payout · {roiTime} GST (UAE)</div>
        <div className="font-display font-bold text-white text-lg font-num">{left || "—"}</div>
      </div>
    </div>
  );
}
